var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticClass:"mr-3",attrs:{"size":"32"}},[_c('img',{attrs:{"src":_vm.jerarquiaPath()}})])}
var staticRenderFns = []

export { render, staticRenderFns }